import React from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo2/mariabarrio.png";
import Imagen2 from "../../../images/modulo2/richibarrio.png";
import Imagen3 from "../../../images/modulo2/mariobarrio.png";
import Imagen4 from "../../../images/modulo2/emiliabarrio.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../../routes/Module2";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo2/Actividad 1.mp3";

const Actividad1 = () => {
  const infoUnidad = modulo2.content[0];
  const infoAct = modulo2.content[0].activities[0];
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title:
        modulo2.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo2.content[0].activities[1].name}`,
    linkNext: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[1].path}`,
    titlePrev: modulo2.title,
    linkPrev: modulo2.url,
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title} - ${infoAct.name}`,
    name: modulo2.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-md-8">
          <p>
            <small className={`c-${modulo2.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

          <ul>
            <li>
              En el Perú, las ciudades se dividen en distritos. En los distritos
              hay diferentes barrios. Los barrios son los lugares en donde
              vivimos con nuestras familias y nos encontramos con nuestros
              vecinos cuando salimos a estudiar, pasear o trabajar.
            </li>
            <li>
              Observa las siguientes imágenes y responde las preguntas
              oralmente.
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-5 col-md-6 col-xs-12">
          <img src={Imagen1} className="img-fluid" alt="Grupo" />
        </div>
        <div className="col-lg-5 col-md-6 col-xs-12">
          <img src={Imagen2} className="img-fluid" alt="Grupo" />
        </div>
        <div className="col-lg-5 col-md-6 col-xs-12">
          <img src={Imagen3} className="img-fluid" alt="Grupo" />
        </div>
        <div className="col-lg-5 col-md-6 col-xs-12">
          <img src={Imagen4} className="img-fluid" alt="Grupo" />
        </div>
      </div>
      <ul className="mt-3">
        <li>¿Cuál es el nombre de tu ciudad y de tu distrito?</li>
        <li>¿Cómo es tu barrio? ¿Qué lugar en tu barrio es el más conocido?</li>
      </ul>
      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y lea las viñetas
          correspondientes. Lea las preguntas y escuche atentamente las
          respuestas. Retome estas respuestas para generar diálogo. Resalte que
          algunos lugares tienen espacios conocidos que los representan.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
